import { createContext, useContext } from 'react';
import type { BoardAlert, BoardFilter, Me, OfficeBoard, RuleDef, RuleId } from '@odd/domain';

export interface BoardCtx {
  board: OfficeBoard;
  me: Me;
  officeId: string;
  rules: Record<RuleId, RuleDef>;
  alerts: BoardAlert[];
  filter: BoardFilter;
  /**
   * Abre la ficha de un caso. Con `sequence` (claves de los casos de una hoja) se abre en «modo rellenar»:
   * la hoja del tándem ya en edición y navegación «caso 1 de 3 · siguiente».
   */
  openCase: (a: BoardAlert, opts?: { sequence?: string[] }) => void;
}

export const BoardContext = createContext<BoardCtx | null>(null);

export function useBoardCtx() {
  const c = useContext(BoardContext);
  if (!c) throw new Error('BoardContext no disponible');
  return c;
}
